import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer'
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer'
import { IAd2cpConfig } from './ad2cp/IAd2cpConfig'


export class IrisrawModAd2cp extends IrisModContainer<IrisConfigContainer<IAd2cpConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModAd2cp.createIrisAd2cpConfig)        
    }

    static createIrisrawModAd2cp(datas:IIrisModContainerConstParam) {        
        return new IrisrawModAd2cp(datas)
    }

    static createIrisAd2cpConfig(data:IIrisConfigContainerConstParam) {        
        return new IrisConfigContainer<IAd2cpConfig>(data)
    }

}
